import styled from "styled-components";

export const HomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: flex-start;

  padding: 1rem;

  text-align: left;

  h1 {
    margin: 0;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: var(--color-text-dark);
  }

  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: var(--color-text-muted);
  }

  h4 {
    margin-top: 60.5px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    color: var(--color-text-lighter);

    text-align: center;
  }
  button.StyledButton-sc-qe3ace-0.cPotLU {
    white-space: normal!important;
    line-height: 1rem;
  }
`;

export const ToggleContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const OrderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  h3 {
    margin: 0;
    font-size: 14px;
    line-height: 150%;
    font-weight: 600;
    color: var(--color-text);
  }
`;
